var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25694 3.09858C9.02154 1.73928 10.9786 1.73928 11.7432 3.09858L17.3235 13.0191C18.0735 14.3523 17.11 15.9996 15.5804 15.9996H4.41978C2.89013 15.9996 1.9267 14.3523 2.67663 13.0191L8.25694 3.09858ZM11 12.9998C11 13.552 10.5523 13.9998 10 13.9998C9.44772 13.9998 9 13.552 9 12.9998C9 12.4475 9.44772 11.9998 10 11.9998C10.5523 11.9998 11 12.4475 11 12.9998ZM10 4.99976C9.44772 4.99976 9 5.44747 9 5.99976V8.99976C9 9.55204 9.44772 9.99976 10 9.99976C10.5523 9.99976 11 9.55204 11 8.99976V5.99976C11 5.44747 10.5523 4.99976 10 4.99976Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.e11382a85246f4e60f59ddcf1d1f9eb8.svg";
export { ForwardRef as ReactComponent };